import * as React from 'react'
import Helmet from 'react-helmet'

export const OgType = () => (
  <Helmet>
    <meta property="og:type" content="website" />
  </Helmet>
)
